import * as type from "../types";
import axios from "axios";

//Authneticate Action
export const authenticate =
  (params = null) =>
  (dispatch) => {
    dispatch({
      type: type.AUTH_REQUEST,
    });

    const config = {
      url: "https://fleet.handsonsystems.com/api/BusinessLogic/AuthenticateUser",
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      data: 'dev+mgcars@handsonsystems.com j6kmx 0 0 0 0',
    };

    return axios(config)
      .then((response) => {
        console.log('authenticate success', response && response.data);
        dispatch({
          type: type.AUTH_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        // Safe error extraction
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : (error && error.message) || 'Unknown authentication error';
        console.error('authenticate failure', message, error);
        dispatch({
          type: type.AUTH_FAILURE,
          payload: message,
        });
      });
  };



